/* eslint-disable react/prop-types */ // TODO: remove
import { Card as MuiCard, CardMedia, CardContent, Typography } from '@mui/material'

import InfoButton from '../InfoButton/InfoButton'
import * as infoButtonStyles from '../InfoButton/styles'

const Styled = {
  ...infoButtonStyles,
}

interface Props {
  title: string

  dangerouslySetInfo?: string
  disabled?: boolean
  isSelected?: boolean
  mediaAlt?: string
  mediaImage?: string
  onClick?: () => void
  onInfoClick?: () => void
  onRemoveClick?: () => void
  titleLong?: string
  type?: 'default' | 'lightweight'
  height?: number
}

const Card: React.FC<Props> = ({
  title,
  type = 'default',
  isSelected = false,
  onClick = () => {},
  onInfoClick,
  dangerouslySetInfo = '',
  onRemoveClick,
  mediaAlt = '',
  mediaImage = '',
  titleLong = '',
  disabled,
  height,
}) => {
  return (
    <MuiCard
      variant="outlined"
      // For refrence see this link https://mui.com/system/getting-started/the-sx-prop/
      sx={{
        position: 'relative',
        width: type === 'lightweight' ? { xs: 110, sm: 365 } : 1,
        height: type === 'lightweight' ? { xs: 'auto', sm: height ?? 120 } : 'auto',
        overflowX: 'visible',
        display: type === 'lightweight' ? { xs: 'block', sm: 'flex' } : 'block',
        gap: type === 'lightweight' ? { xs: 'normal', sm: '15px' } : 'normal',
        p: isSelected ? '1px' : '2px',
        ...(isSelected && {
          borderWidth: '2px',
          borderColor: 'primary.light',
          boxShadow: '1px 3px 6px rgb(0 0 0 / 16%)',
        }),
        alignItems: type === 'lightweight' ? { xs: 'normal', sm: 'center' } : 'normal',
        '&:hover': {
          boxShadow: '1px 3px 6px rgb(0 0 0 / 16%)',
          cursor: 'pointer',
        },
        opacity: disabled ? 0.3 : 1,
        '@media (min-width: 1200px)': {
          width: 1,
        },
      }}
      onClick={onClick}
    >
      {isSelected && onRemoveClick && (
        <button
          className="button-remove"
          onClick={(event) => {
            event.stopPropagation()
            onRemoveClick()
          }}
        >
          <i className="far fa-trash-alt" aria-hidden="true" />
        </button>
      )}
      <CardMedia
        component="img"
        alt={mediaAlt}
        // For refrence see this link https://mui.com/system/getting-started/the-sx-prop/
        sx={{
          height: type === 'lightweight' ? 70 : 'auto',
          width: type === 'lightweight' ? 'auto' : 1,
          m: type === 'lightweight' ? '0 auto' : '0 0 auto 0',
          pl: type === 'lightweight' ? { xs: 0, lg: '15px' } : 0,
        }}
        image={mediaImage}
      />
      <CardContent
        // For refrence see this link https://mui.com/system/getting-started/the-sx-prop/
        sx={{
          position: 'relative',
          p: type === 'lightweight' ? '16px 8px' : 1,
          width: type === 'lightweight' ? { xs: 'auto', lg: '70%' } : 1,
          '&:last-child': { paddingBottom: '16px' },
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            textAlign: type === 'lightweight' ? { xs: 'center', sm: 'start' } : '',
            textTransform: 'none',
          }}
        >
          {title}
        </Typography>
        {titleLong && (
          <Typography
            variant="caption"
            sx={{
              display: type === 'lightweight' ? { xs: 'none', sm: 'block' } : '',
              textTransform: 'none',
            }}
          >
            {titleLong}
          </Typography>
        )}
      </CardContent>
      {onInfoClick ? (
        <Styled.InfoButton
          context="Card"
          onClick={(event) => {
            event.stopPropagation()
            onInfoClick()
          }}
        >
          <i className="fas fa-info" aria-hidden="true" />
        </Styled.InfoButton>
      ) : dangerouslySetInfo ? (
        <InfoButton context="Card" hideOnDesktop={type === 'lightweight'} dangerouslySetInfo={dangerouslySetInfo} />
      ) : null}
    </MuiCard>
  )
}

export default Card
